import { initSegement, segmentTrackLessonCompletion } from './segment';

import identifyPage from './identifyPage';

import injectPromoBanner from './promo-banner';
import injectNavBar from './navbar';
import injectMobileBanner from './mobile-banner';
import updateSJCards from './cards';
import injectFooter from './footer';
import updateCoursePages from './courses';
import addComingSoonTags from './coming-soon';
import handleTimeEstimates from './time-estimates';
import updatePathPages from './learning-path';
import updatePartnerNavLinks from './partner-nav';
import checkForPartnerGroup from './partner-check';

import injectHomePage from './page/homepage';
import injectPartnerPage from './page/partners';
import updateProfilePage from './page/profile';
import updateClickTipsPage from './page/clicktips';
import updatePaywall from './page/paywall';
import updateCourseCatalog from './page/course-catalog';
import updateGuestsPage from './page/guests';
import updateCertificatesPage from './page/certificates';
import updateLiveTrainingPage from './page/live-training';

// ================ //
// sitewide updates //
// ================ //

// segment tracking
segmentTrackLessonCompletion();

// Adds a ids/classes to the body based on page/path
// ** MUST COME BEFORE ANY OTHER PAGE UPDATE CODE **
identifyPage();

// navigation bar
try {
    injectNavBar();
} catch(e) {
    console.error("Couldn't add navigation bar!", e);
}

// mobile banner message
injectMobileBanner();

// SJ course cards
updateSJCards();

// "Coming Soon" card tags
addComingSoonTags();

// Time estimate tags
handleTimeEstimates();

// inject footer
injectFooter();


let body = document.body;

// ================ //
// add promo banner //
// ================ //

// ...to the homepage
if (body.classList.contains("home-page")) {
    injectPromoBanner();
}


// ==================== //
// update section pages //
// ==================== //

// learning path pages
if (document.body.classList.contains('learning-path-page')) {
    updatePathPages();
}

// courses pages
if (body.classList.contains('sj-page-series')) {
    updateCoursePages();
}


// ======================= //
// update individual pages //
// ======================= //

// homepage
if (body.classList.contains("home-page")) {
    injectHomePage();
}

// partners page
if (body.classList.contains("partners")) {
    injectPartnerPage();
    updatePartnerNavLinks();
}

// partner nav updates
if (body.classList.contains("partner-development")) {
    updatePartnerNavLinks();
}

// sitewide nav updates for student in a partner group
if (checkForPartnerGroup()) {
    updatePartnerNavLinks();
}

// profile page
if (body.classList.contains("sj-page-profile")) {
    updateProfilePage();
}

// course catalog / all courses page
if (body.classList.contains('course-catalog')) {
    updateCourseCatalog();
}

// clicktips page
if (body.classList.contains('clicktips')) {
    updateClickTipsPage();
}

// guests-start-here page
if (body.classList.contains('guests-start-here')) {
    updateGuestsPage();
}

// update course purchase checkout page
if (body.classList.contains('sj-page-checkout')) {
    updatePaywall();
}

// update certificates page
if (body.classList.contains('certificates')) {
    updateCertificatesPage();
}

// update live training page
if (body.classList.contains('live-training')) {
    updateLiveTrainingPage();
}


// TODO: Finish deprecating or refactoring all code below into modules

// ================================================== //
// create page headers for custom search filter pages //
// ================================================== //

try {
    let pageList = [
        'productivity-expert',
        'productivity-all-star',
        'productivity-pro',
        'use-cases',
        'webinars',
    ];

    for (let page of pageList) {
        if (body.classList.contains(page)) {
            let mainContainer = document.querySelector('#main-container');
            let pageHeader = document.createElement('H1');
            let searchContainer = document.querySelector('.search-container');
            let subtext = document.createElement('H2');
            
            switch (page) {
                case 'productivity-expert':
                    pageHeader.innerText = 'Productivity Expert'
                    subtext.innerText = "As a ClickUp Productivity Expert, you'll have all the admin skills you need to manage and configure your Workspace with ease.";
                    break;
                case 'productivity-all-star':
                    pageHeader.innerText = 'Productivity All-Star'
                    subtext.innerText = "As a ClickUp Productivity All-Star, you'll have all the skills you need to build the most efficient Workspace and optimize your workflow.";
                    break;
                case 'productivity-pro':
                    pageHeader.innerText = 'Productivity Pro'
                    subtext.innerText = "Take a deeper dive into core features and productivity tips to grow your skills and earn ClickUp badges.";
                    break;
                case 'use-cases':
                    pageHeader.innerText = 'Use Cases'
                    subtext.innerText = "Choose the ClickUp use case for your business goals. Each learning path includes courses of varying levels.";
                    break;
                    break;
                case 'webinars':
                    pageHeader.innerText = 'On-Demand Webinars'
                    subtext.innerText = "";
                    break;
                // case 'clicktips':
                //     pageHeader.innerText = 'ClickTips'
                //     subtext.innerText = "Get quick tips and tutorials to help you reach your productivity goals with ClickUp.";
                //     break;
                default:
                    break;
            }
            
            searchContainer.prepend(pageHeader);
            searchContainer.append(subtext);
            mainContainer.prepend(searchContainer);
            break;
        }
    }
    
} catch {
}


// ================================================== //
// add functionality to show and hide the lesson menu //
// ================================================== //

try {
    let lessonPage = document.querySelector('.sj-page-lesson #main-container');
    let menuBtn = document.createElement('div');
    let lessonMenu = document.querySelector('.sj-page-lesson #lp-left-nav');
    menuBtn.id = 'menu-btn';
    menuBtn.addEventListener('click', () => {
        if (lessonMenu.style.display === 'block') {
            lessonMenu.style.display = 'none';
        } else {
            lessonMenu.style.display = 'block';
        }
    });
    lessonPage.prepend(menuBtn);
} catch {
}


// ============================== //
// add breadcrumbs to plans pages //
// ============================== //

try {
    let planHeader = document.querySelector('.plans-page .dp-summary-wrapper');
    let breadcrumbs = document.createElement('div');
    breadcrumbs.id = 'plan-breadcrumbs';
    breadcrumbs.innerHTML = `
        <a class="home-link" href="/">Home</a>
        <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.7" fill-rule="evenodd" clip-rule="evenodd" d="M1 3.99631H12.5895L10.3003 1.70711C9.90982 1.31658 9.90982 0.683417 10.3003 0.292893C10.6909 -0.0976314 11.324 -0.0976307 11.7146 0.292894L15.707 4.2853C15.8921 4.4704 15.9894 4.71001 15.9991 4.95245C15.9997 4.96699 16 4.98161 16 4.99631C16 5.27773 15.8838 5.53199 15.6967 5.71371L11.707 9.70339C11.3165 10.0939 10.6833 10.0939 10.2928 9.70339C9.90225 9.31286 9.90225 8.6797 10.2928 8.28917L12.5856 5.99631H1C0.447715 5.99631 0 5.54859 0 4.99631C0 4.44402 0.447715 3.99631 1 3.99631Z" fill="#B9BEC7"/>
        </svg>
        <a class="live-training-link" href="/page/live-training">Live Training</a>
    `;

    planHeader.prepend(breadcrumbs);
} catch {
}


// ===================================== //
// add breadcrumbs to plan catalog pages //
// ===================================== //

try {
    let planHeader = document.querySelector('.getting-started-with-clickup-workshop-bundle .catalog-header');
    let breadcrumbs = document.createElement('div');
    breadcrumbs.id = 'plan-breadcrumbs';
    breadcrumbs.innerHTML = `
        <a class="home-link" href="/">Home</a>
        <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.7" fill-rule="evenodd" clip-rule="evenodd" d="M1 3.99631H12.5895L10.3003 1.70711C9.90982 1.31658 9.90982 0.683417 10.3003 0.292893C10.6909 -0.0976314 11.324 -0.0976307 11.7146 0.292894L15.707 4.2853C15.8921 4.4704 15.9894 4.71001 15.9991 4.95245C15.9997 4.96699 16 4.98161 16 4.99631C16 5.27773 15.8838 5.53199 15.6967 5.71371L11.707 9.70339C11.3165 10.0939 10.6833 10.0939 10.2928 9.70339C9.90225 9.31286 9.90225 8.6797 10.2928 8.28917L12.5856 5.99631H1C0.447715 5.99631 0 5.54859 0 4.99631C0 4.44402 0.447715 3.99631 1 3.99631Z" fill="#B9BEC7"/>
        </svg>
        <a class="live-training-link" href="/page/live-training">Live Training</a>
    `;

    planHeader.prepend(breadcrumbs);
} catch {
}


// ============================================= //
// add plan labels to course cards on plan pages //
// ============================================= //

const generatePlanLabel = (allLabels) => {
    let labelOptions = {
        "all-plans": "All Plans",
        "free-forever": "Free Forever",
        "unlimited": "Unlimited",
        "business": "Business",
        "business-plus": "Business Plus",
        "enterprise": "Enterprise",
    };
    let formattedLabels = [];

    for (let label of allLabels) {
        if (labelOptions[label]) {
            formattedLabels.push(labelOptions[label])
        }
    }

    if (formattedLabels.length > 1 || formattedLabels[0] === "All Plans") {
        return `Plans: <strong>${formattedLabels.join(', ')}</strong>`
    } else if (formattedLabels.length === 0) {
        return ''
    }

    return `Plan: <strong>${formattedLabels.join(', ')}</strong>`
}

try {
    let allCourseCards = document.querySelectorAll('.getting-started-with-clickup-workshop-bundle a.coursebox-container');

    for (let card of allCourseCards) {
        let label = document.createElement('div');
        label.classList.add('plan-label');
        label.innerHTML = generatePlanLabel(card.dataset.tags.split(','));

        for (let child of card.children) {
            if (child.classList.contains('coursebox-text')) {
                child.prepend(label);
            }
            
            // Update button text
            if (child.classList.contains('coursebox-callout') && 
            !child.classList.contains('course-time')) {
                child.innerHTML = "View";
            }
        }
    }
} catch {
}


// ===================================================== //
// add functionality to hide lessons from search results //
// ===================================================== //

/**
 * This function was provided by SkillJar
 * to handle missing functionality in the Admin UI
 */
$(document).ready(function(){
    $('#catalog-search-box').on('keydown', function () {
        $('#catalog-courses').find($('.lesson')).remove();
        $('#filter_type_-l').hide();
        $('#filter_type_-c').hide();
        $('#filter_type_-p').hide();
    });
    if(window.location.href.includes('q=')){
        $('#catalog-courses').find($('.lesson')).remove();
        $('#filter_type_-l').hide();
        $('#filter_type_-c').hide();
        $('#filter_type_-p').hide();
    }
});

/**
 * Please do not insert code after the above SkillJar function(s)
 */
